// Centralized control for the floating support widget (SuperAGI LiveChat).
//
// The widget is injected externally and renders two fixed, max-z-index elements
// on <body>: the launcher bubble (#livechat_widget_launcher) and the expanded
// chat window (#livechat_widget). Its own window.SuperAGILiveChat.hide() does NOT
// hide the launcher (it only collapses the chat back to the bubble), so we toggle
// the elements' inline display directly.
//
// A reference count lets multiple opt-in drawers overlap safely: the widget is
// only restored once the last opt-in consumer releases it.
//
// Generic by design — fold additional support surfaces (e.g. Intercom) in here
// rather than touching individual drawers.

const SUPPORT_WIDGET_IDS = ["livechat_widget_launcher", "livechat_widget"];

let hiddenCount = 0;
// Per-element inline `display` captured at hide time, keyed by element id, so
// we can restore each element to exactly the state it was in before we hid it.
let savedDisplays = null;

const hideSupportWidgetEls = () => {
  savedDisplays = {};
  SUPPORT_WIDGET_IDS.forEach((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    // Remember the prior inline value ("" for the launcher, usually "none" for
    // the collapsed chat panel) before forcing everything hidden.
    savedDisplays[id] = el.style.display;
    el.style.display = "none";
  });
};

const restoreSupportWidgetEls = () => {
  SUPPORT_WIDGET_IDS.forEach((id) => {
    const el = document.getElementById(id);
    // Reapply the exact prior inline value rather than blanket-clearing it.
    // The chat panel (#livechat_widget) is kept collapsed by the library via an
    // inline display:none; clearing it would force the panel open after every
    // hide/show cycle.
    if (el) el.style.display = savedDisplays?.[id] ?? "";
  });
  savedDisplays = null;
};

export const hideSupportWidget = () => {
  hiddenCount += 1;
  if (hiddenCount === 1) {
    hideSupportWidgetEls();
  }
};

export const showSupportWidget = () => {
  if (hiddenCount === 0) return;
  hiddenCount -= 1;
  if (hiddenCount === 0) {
    restoreSupportWidgetEls();
  }
};
